
define('text!views/shared/error/error.html',[],function () { return '<!DOCTYPE html>\r\n<html xmlns="http://www.w3.org/1999/xhtml">\r\n<head>\r\n    <title></title>\r\n</head>\r\n<body>\r\n  <!-- Message if we want to show it-->\r\n</body>\r\n</html>\r\n';});

